/**
 * Updates 'defect-disclaimer' text to reflect size chosen
 * @module updateDefectDisclaimer
 */

import $ from 'jquery';

export const EL_CLASS = 'defect-disclaimer';

/**
 * Initializes 'defect disclaimer' text changes.
 * @param {HTMLElement} wrap - The closest wrap from the select
 * @param {Object} chosen - Information on the selected size
 * @return {jQuery} defect-disclaimer element
 */
export default function updateDefectDisclaimer({ wrap, chosen = {} }) {
  const { 'defect-disclaimer': defectDisclaimer } = chosen;

  const $el = $(wrap).find(`.${EL_CLASS}`);

  if (defectDisclaimer) {
    $el.html(`${defectDisclaimer}`);
  } else {
    $el.empty();
  }

  return $el;
}



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/defect-disclaimer-update.js